import {useRef} from "react"

export const useHelp = () => {
    const context = useRef(null)
    const contextOnce = useRef(null)

    const getContext = () => context.current
    const setContext = (page) => context.current = page
    const unsetContext = () => context.current = null
    const setContextOnce = (page) => contextOnce.current = page
    const getContextOnce = () => {
        const context = contextOnce.current
        contextOnce.current = null
        return context
    }

    return {getContext, setContext, unsetContext, setContextOnce, getContextOnce}
}
